import axiosInstance from "../../utility/axios";

import { set_cookie, delete_cookie } from "../../utility/cookies";

// state
import { setLoading, disableLoading } from "../../store/slices/loading";
import { setUser } from "../../store/slices/auth";
import { AppDispatch } from "../../store/store";
import { NavigateFunction } from "react-router-dom";
import { IAuthUser } from "../../store/types/user";

export const authUser = async (
  data: IAuthUser,
  dispatch: AppDispatch,
  navigate: NavigateFunction
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post("/login", data);
    if (response.data) {
      set_cookie("@serial", response?.data?.access_token);
      navigate("/");
    }
  } catch (err) {
    console.log(err);
  }
  dispatch(disableLoading());
};

export const getAuthUser = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get("/user");
    dispatch(setUser(response.data));
  } catch (err) {
    console.log(err);
  }
  dispatch(disableLoading());
};

export const logout = async () => {
  try {
    await axiosInstance.get("/logout");

    delete_cookie("@serial");
  } catch (error) {}
};
